export default __webpack_public_path__ + "static/media/Orginal Högblank Fernissa.e6676ddb.jpg";